'use strict';

var _defineProperty = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/defineProperty");

var T = require('../../message').TYPES;
/**
 *
 * @param {import('../../index')} dht
 */


module.exports = function (dht) {
  var _handlers;

  var handlers = (_handlers = {}, _defineProperty(_handlers, T.GET_VALUE, require('./get-value')(dht)), _defineProperty(_handlers, T.PUT_VALUE, require('./put-value')(dht)), _defineProperty(_handlers, T.FIND_NODE, require('./find-node')(dht)), _defineProperty(_handlers, T.ADD_PROVIDER, require('./add-provider')(dht)), _defineProperty(_handlers, T.GET_PROVIDERS, require('./get-providers')(dht)), _defineProperty(_handlers, T.PING, require('./ping')(dht)), _handlers);
  /**
   * Get the message handler matching the passed in type.
   *
   * @param {number} type
   */

  function getMessageHandler(type) {
    // @ts-ignore ts does not aknowledge number as an index type
    return handlers[type];
  }

  return getMessageHandler;
};